import React from 'react';
import { cn } from 'src/tef/components/utils/cn';

interface KeyboardKeyProps {
  children: React.ReactNode;
  className?: string;
}

export default function KeyboardKey({ children, className }: KeyboardKeyProps) {
  return (
    <kbd
      className={cn(
        'inline-flex items-center justify-center',
        'min-w-[1.5rem] px-1.5 py-0.5',
        'font-mono text-xs',
        'bg-slate-100 dark:bg-slate-700',
        'text-slate-700 dark:text-slate-200',
        'border border-slate-300 dark:border-slate-600',
        'rounded',
        'shadow-sm',
        className
      )}
    >
      {children}
    </kbd>
  );
}

export { KeyboardKey };
